let loader = document.querySelector(".collection-loader");
let filterOptions = document.querySelectorAll(".filter-option");
let priceFilters = document.querySelectorAll(".price-filter");
let sortSelect = document.querySelector(".sort-collection");
let cardView = document.querySelector(".card-view");
let maxPriceInput = document.querySelector(".price-filter.max");
let minPriceInput = document.querySelector(".price-filter.min");
let currentPage = window.location.search.includes("page")
  ? window.location.search.match(/page=(\d+)/)[0].match(/\d+/)[0]
  : "1";
let currentSort = window.location.search.includes("sort_by")
  ? window.location.search.substring(
      window.location.search.indexOf("sort_by=") + "sort_by=".length
    )
  : "";
let filterObjectArray = [];
let priceFilterArray = [];
filterOptions.forEach(function (el, ind) {
  el.addEventListener("change", function (e) {
    currentPage = 1;
    let filter = {
      type: el.dataset.param,
      value: el.dataset.value,
    };
    if (el.checked) {
      filterObjectArray.push(filter);
    } else {
      filterObjectArray = filterObjectArray.filter(
        (el) => el.value != filter.value
      );
    }
    generateUrl();
  });
});
(function getCurrentFilters() {
  let searchParams = window.location.search.replace("?", "");
  if (searchParams.includes("filter")) {
    let filterArray = searchParams.includes("&")
      ? searchParams.split("&")
      : [searchParams];
    filterArray.forEach(function (el, ind) {
      if (el.includes("filter") && !el.includes("price")) {
        let object = {
          type: el.split("=")[0],
          value: el.split("=")[1],
        };
        filterObjectArray.push(object);
      }
    });
  }
})();
function generateUrl() {
  let filterUrl = "";
  currentSort = currentSort.includes("&")
    ? currentSort.split("&")[0]
    : currentSort;
  filterObjectArray.forEach(function (el, ind) {
    ind == 0
      ? (filterUrl += `?${el.type}=${el.value}`)
      : (filterUrl += `&${el.type}=${el.value}`);
  });
  priceFilterArray.length > 1
    ? priceFilterArray.forEach(function (el, ind) {
        filterUrl.includes("?")
          ? (filterUrl += `&${el.type}=${el.value}`)
          : (filterUrl += `?${el.type}=${el.value}`);
      })
    : "";
  filterUrl.includes("?")
    ? (filterUrl += `&page=${currentPage}`)
    : (filterUrl += `?page=${currentPage}`);
  currentSort.trim().length > 1 ? (filterUrl += `&sort_by=${currentSort}`) : "";
  console.log(filterUrl);
  updateUrl(filterUrl);
}
function updateUrl(url) {
  let currentPath = window.location.pathname;
  url.trim().length >= 1
    ? window.history.pushState("", "", url)
    : window.history.pushState("", "", currentPath);
  let fetchUrl = window.location.pathname + window.location.search;
  fetchUrl.includes("?")
    ? (fetchUrl += `&view=ajax`)
    : (fetchUrl += `?viewajax`);
  fetchProducts(fetchUrl);
}
function fetchProducts(url) {
  loader.classList.add("active");
  console.log(url);
  fetch(url)
    .then((response) => response.text())
    .then((data) => {
      let parser = new DOMParser();
      let html = parser.parseFromString(data, "text/html");
      let productCardHtml = html.querySelector(
        ".collection-products-list-wrap"
      ).innerHTML;
      let activeFiltersHtml = html.querySelector(".active-filters").innerHTML;
      let paginateHtml = html.querySelector(".paginate-wrap").innerHTML;
      document.querySelector(".collection-products-list-wrap").innerHTML = "";
      document.querySelector(".active-filters").innerHTML = "";
      document.querySelector(".paginate-wrap").innerHTML = "";
      document.querySelector(".collection-products-list-wrap").innerHTML =
        productCardHtml;
      document.querySelector(".active-filters").innerHTML = activeFiltersHtml;
      document.querySelector(".paginate-wrap").innerHTML = paginateHtml;
      loader.classList.remove("active");
      disableUnavailableVariantCollection();
    })
    .catch((err) => console.error(err));
}
//////////////////////////Price filter
const updateprice = filterDebounce(() => {
  priceFilterArray = [];
  priceFilters.forEach(function (el, ind) {
    let priceData = {
      type: el.dataset.value,
      value: el.value,
    };
    priceFilterArray.push(priceData);
  });
  generateUrl();
});
priceFilters.forEach(function (el, ind) {
  el.addEventListener("change", function () {
    updateprice();
    currentPage = 1;
  });
});
function filterDebounce(callback) {
  let timer;
  return (...args) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      callback(...args);
    }, 1000);
  };
}
///////////////////////////sorting
if (sortSelect) {
  sortSelect.addEventListener("change", function () {
    currentSort = this.value;
    generateUrl();
  });
}
//////////////////////////////Card view change
if(cardView){
  cardView.addEventListener("change", function (e) {
    let rootStyle = document.querySelector(":root");
    rootStyle.style.setProperty("--collection-cards-row-desktop", this.value);
  });
}
/////////////////////////////Price range bar
var lowerSlider = document.querySelector("#lower"),
  upperSlider = document.querySelector("#upper"),
  lowerVal = parseInt(lowerSlider.value);
upperVal = parseInt(upperSlider.value);

upperSlider.oninput = function () {
  lowerVal = parseInt(lowerSlider.value);
  upperVal = parseInt(upperSlider.value);
  maxPriceInput.value = upperVal;
  minPriceInput.value = lowerVal;
  let event = new Event("change");
  maxPriceInput.dispatchEvent(event);
  minPriceInput.dispatchEvent(event);
  if (upperVal < lowerVal + 4) {
    lowerSlider.value = upperVal - 4;

    if (lowerVal == lowerSlider.min) {
      upperSlider.value = 4;
    }
  }
};

lowerSlider.oninput = function () {
  lowerVal = parseInt(lowerSlider.value);
  upperVal = parseInt(upperSlider.value);
  maxPriceInput.value = upperVal;
  minPriceInput.value = lowerVal;
  let event = new Event("change");
  maxPriceInput.dispatchEvent(event);
  minPriceInput.dispatchEvent(event);
  if (lowerVal > upperVal - 4) {
    upperSlider.value = lowerVal + 4;

    if (upperVal == upperSlider.max) {
      lowerSlider.value = parseInt(upperSlider.max) - 4;
    }
  }
};
//////////////////////Filters expand and shrink toggle
document.addEventListener("click",(e)=>{
  if(e.target.classList.contains("filter-button") || e.target.closest(".filter-button") || e.target.classList.contains("load-filters") || e.target.closest(".load-filters") ){
    let el = e.target;
    let filterWrap = el.closest(".filter-block-wrap");
    filterWrap.classList.toggle("open")
  }
})